/* ==========================================================================
   CLARITY HEALTH CO — ONE FORMULA. EVERY OCCASION.  (dose-style redesign)
   A single-open accordion of occasions. Opening a row height-animates its
   panel, cross-fades the right-hand media stage to that occasion's image and
   swaps the product description. Add-to-cart uses the shared Clarity cart.
   Honours prefers-reduced-motion (no fades / instant text swap; CSS drops the
   transitions so the height set is instant too).
   ========================================================================== */
(function () {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-clarity-fn]').forEach((sec) => {
    const items = Array.from(sec.querySelectorAll('.clarity-dose__item'));
    const shots = Array.from(sec.querySelectorAll('.clarity-dose__shots img'));
    const desc = sec.querySelector('[data-fn-desc]');
    if (!items.length) return;

    let descs = [];
    const dEl = sec.querySelector('[data-fn-desc-data]');
    if (dEl) { try { descs = JSON.parse(dEl.textContent); } catch (e) { descs = []; } }

    const panelOf = (it) => it.querySelector('.clarity-dose__panelbody');
    const btnOf = (it) => it.querySelector('.clarity-dose__hdr');

    const setOpen = (it, open) => {
      const btn = btnOf(it);
      const panel = panelOf(it);
      btn.setAttribute('aria-expanded', String(open));
      it.classList.toggle('is-open', open);
      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
      } else if (panel.style.height !== '0px') {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(() => { panel.style.height = '0px'; });
      }
    };

    const select = (i) => {
      items.forEach((it, k) => setOpen(it, k === i));
      shots.forEach((im, k) => im.classList.toggle('is-on', k === i));
      if (desc) {
        const t = descs[i] != null ? descs[i] : '';
        if (reduce) { desc.textContent = t; }
        else { desc.style.opacity = '0'; setTimeout(() => { desc.textContent = t; desc.style.opacity = '1'; }, 200); }
      }
    };

    items.forEach((it, i) => {
      const panel = panelOf(it);
      if (panel.dataset.open) panel.style.height = 'auto';
      panel.addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'height') return;
        if (btnOf(it).getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
      });
      btnOf(it).addEventListener('click', () => {
        // Collapse if it's already the open one; otherwise open it (closing the rest)
        // and move the media stage + description to match.
        if (it.classList.contains('is-open')) { setOpen(it, false); return; }
        select(i);
      });
    });

    window.addEventListener('resize', () => {
      const open = items.find((it) => it.classList.contains('is-open'));
      if (open) panelOf(open).style.height = 'auto';
    });
  });
})();
